import React from 'react'

const ImageFullScreen = ({src, onClose}) => {
  return (
    <div className="fixed z-40 inset-0 overflow-y-auto">
      <div onClick={onClose} className="flex items-end justify-center h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div className="inline-block text-center text-gray-600 h-2/3 w-1/2 align-bottom rounded-lg bg-white overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <img alt='img' src={src} className="h-full w-full transition-transform duration-500 ease-in-out transform hover:scale-150" />
        </div>
      </div>
    </div>
  )
}

export default ImageFullScreen